
import React, { useState } from 'react';
import DownloaderField from './DownloaderField';
import DownloaderList from './DownloaderList';
import CommentList from './CommentList';
import UserList from './UserList';
import SealList from './SealList';
import SettingShow from './SettingShow';
import DownloadQuestionList from './DownloadQuestionList';

export default function DownloaderAdmin(props) {
   
    const [showNewAdd, SetShowNewAdd] = useState(0);
    const [selectItemId, SetSelectItemId] = useState('');
    const [subject, Setsubject] = useState('');
    const handelShowComponent = (value, id, subject) => {
        SetShowNewAdd(value);
        SetSelectItemId(id);        
        Setsubject(subject);
    }
    return (
        <div  style={{marginTop:"20px",backgroundColor:"white",width:"100%",textAlign:"right"}}>
            <div className="nav-tabs-custom">
                <ul className="nav nav-tabs">
                    <li className="active"><a href="#tabDownload" data-toggle="tab" style={{ textDecoration: "none" }}>محصولات</a></li>
                    <li><a href="#tabUser" data-toggle="tab" style={{ textDecoration: "none" }}>کاربران</a></li>
                    <li><a href="#tabSetting" data-toggle="tab" style={{ textDecoration: "none" }}>تنظیمات</a></li>
                    <li><a href="#tabSeal" data-toggle="tab" style={{ textDecoration: "none" }}>فهرست فروش</a></li>
                </ul>

            </div>
            <div className="tab-content">
                <div className="tab-pane active" id="tabDownload">
                    {showNewAdd === 0 && <DownloaderList onSetshowlist={handelShowComponent} UserId={props.UserId}/>}
                    {showNewAdd === 1 && <DownloaderField onSetshowField={handelShowComponent} selectItemId={selectItemId} UserId={props.UserId}/>}
                    {showNewAdd === 2 && <CommentList onSetshowlist={handelShowComponent} subject={subject} selectItemId={selectItemId} />}
                    {showNewAdd === 3 && <DownloadQuestionList onSetshowlist={handelShowComponent} subject={subject} selectItemId={selectItemId} />}
                </div>
                <div className="tab-pane" id="tabUser">
                    <UserList/>
                </div>
                <div className="tab-pane" id="tabSetting">
                    <SettingShow/>
                </div>
                <div className="tab-pane" id="tabSeal">
                    <SealList/>
                </div>
            </div>

        </div>

    );
}